// store.js
import { configureStore } from '@reduxjs/toolkit';

import apiCall from './reducers/apiCall.js';
import mapViewSelector from './reducers/mapViewSelector.js';
import geographicalDataReducer from './reducers/fmAPI.js';
import csrHandler from './reducers/csrHandler.js';
import appContext from './reducers/appContext.js';
import cdvState from './reducers/cdvState.js';
import errorState from './reducers/errorState.js';

const preloadedState = typeof window !== 'undefined' ? window.__INITIAL_STATE__ : {};


export const initialReducer = {
  fmAPI: geographicalDataReducer,
  api: apiCall,
  mapViewSelector: mapViewSelector,
  csrHandler: csrHandler,
  appContext: appContext,
  cdvState: cdvState,
  errorState: errorState,
}

export const createReduxStore = (preloadedState) => {
  return configureStore({
    reducer: initialReducer,
    preloadedState
  });
};

/**
 * CSR Store
 */
export const store = createReduxStore(preloadedState);